import HTTP from './AxiosConfig'

// Auth
export function login (params) { return HTTP.post('login', params) }
export function logout () { return HTTP.post('logout') }

// Profile
export function profile () { return HTTP.get('profiles') }
export function updateProfile (user) { return HTTP.post('profiles', user) }
export function changePassword (password) { return HTTP.post('profiles/change-password', password) }

// FAQ / Group FAQ
export function getListGroupFAQ (params) { return HTTP.get('group-faqs', {params}) }
export function showGroupFAQ (id) { return HTTP.get('group-faqs/' + id) }
export function createGroupFAQ (params) { return HTTP.post('group-faqs', {params}) }
export function updateGroupFAQ (id, params) { return HTTP.put('group-faqs/' + id, params) }
export function destroyGroupFAQ (id) { return HTTP.delete('group-faqs/' + id) }
export function approvalGroupFAQ (id) { return HTTP.post('group-faqs/' + id + '/approval') }
export function rejectGroupFAQ (id) { return HTTP.post('group-faqs/' + id + '/rejection') }

// Checklist
export function getAssessmentTeam (id) { return HTTP.get(`checklists/${id}/users`) }



// WEBPACK FOOTER //
// ./src/service/Apis.js